import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { inject, Injector } from '@angular/core';
import { ErrorHandlerService } from '../services/error-handler.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  const retryCount = req.method === 'GET' ? 2 : 0;

  return next(req).pipe(
    retry(retryCount),
    catchError((error) => {
      const errorHandler = injector.get(ErrorHandlerService);
      return errorHandler.handleError(error);
    }),
  );
};
